import React, { useCallback, useContext } from 'react';
import cuid from 'cuid';
import { FileUpload } from '@lmig/lmds-react-file-upload';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import ThumbnailsGrid from '../Components/ThumbnailsGrid';
import { FormContext } from '../FormContext/FormContext';
import { Heading,BodyText,Table,TableHeader,TableRow,TableCell,TableBody,IconButton,IconTrash,DataTable
  ,AlphanumericInput,Select,SelectOption,FieldGroup } from '@lmig/lmds-react';
import { setAcceptedFiles,setCategoryText,setPhotoText } from '../FormContext/UploadsContext';
import { MAX_FILE_SIZE, MAX_TOTAL_FILE_SIZE, MAX_FILE_COUNT, MIN_FILE_SIZE,UPLOADS } from '../constants';
import { log } from '../logger';


// eslint-disable-next-line react/prop-types
const DocumentUpload = ({ category,  heading, subHeading, text, hasError }) => {
  const [values, handleSetValues] = useContext(FormContext);
 

  const filterFilesByCategory = values.activeStep === 2 ? values.uploads.files.filter((file) => file.category === 'estimate') :
    values.uploads.files.filter((file) => (file.category !== 'estimate'));
  const oneValidFile = values.uploads.files.some((file) => file.category === 'estimate');

  
 


  const [finalFiles, setFinalFiles] = React.useState(filterFilesByCategory);
  const [uploadedFiles, setUploadedFiles] = React.useState(true);
  const handleDelete = (fileToDelete) => {
    setFinalFiles((prevFiles) => prevFiles.filter((file) => file !== fileToDelete));
    handleSetValues('filesRemoved', fileToDelete.id);
};
  const  handleSelection = (fileId,selectedValue) => {
   const value = values.uploads.files.findIndex((file) => file.id === fileId.id);
   
   values.uploads.files[value].category = selectedValue.target.value;
  };
  const getSelectedOption = (category) => {
  if (category === 'photos') return 'photos';
  if (category === 'other') return 'other';
  return '';
};
  // Usage in component

const StyledSelect = styled(Select)`
  width: 200px;
  min-width: 200px;
`;
  const isMobile = window.innerWidth <= 768;
  
  const ERROR_HEIGHT = '16px';

 const shouldForwardProp = (prop) => prop !== '$isMobile';

 const ResponsiveTableRow = styled(TableRow, { shouldForwardProp })`
  display: flex;
  max-width: 665px;
  height: auto;
  min-height: ${(props) => props.$isMobile ? '297px' : '252px'};
  flex-direction: ${(props) => props.$isMobile ? 'column' : 'row'};
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  padding-bottom: ${(props) => props.$isMobile ? '16px' : '0'};
`;

 const ContentCell = styled(TableCell, { shouldForwardProp })`
   && {
    align-self: flex-start !important;
    width: ${(props) => props.$isMobile ? '100%' : '350px'} !important;
    max-width: ${(props) => props.$isMobile ? '100%' : '350px'} !important;
    position: ${(props) => props.$isMobile ? 'absolute' : 'static'} !important;
    top: ${(props) => props.$isMobile ? '0' : 'auto'} !important;
    padding-bottom: ${(props) => props.$isMobile ? '0px !important' : ''};
    padding-top: ${(props) => props.$isMobile ? '0px !important' : ''};
    display: flex;
    flex-direction: column;
   }
`;

 const StyledTableWrapper = styled('div')`
 .lmig-Table-wrapper--inner {
   overflow-x: hidden !important;
  }
  .lmig-Table {
    max-width: 665px;
   
    
    
    && {
      border: none;
      background: transparent;
      box-shadow: none;
    }

    .lmig-TableBody {
      border: none;
    }

    .lmig-TableRow {
      border-bottom: 1px solid #E5E5E5;
    }
  }
`;

 const ControlsCell = styled(TableCell, { shouldForwardProp })`
  display: flex;
  width: ${(props) => props.$isMobile ? '100%' : '35%'};
  position: ${(props) => props.$isMobile ? 'absolute' : 'static'};
    bottom: 0px;
  
  left: 0;
  height:auto !important;
  padding-top: ${(props) => props.$isMobile ? '16px !important' : '12px !important'};
  padding-bottom: ${(props) => props.$isMobile ? '0px !important' : ''};
  background: ${(props) => props.$isMobile ? '#fff' : 'transparent'};
  z-index: 1;
   @media (max-width: 768px) {
    bottom: 18px;
  }
`;

  const onDrop = useCallback((acceptedFiles,rejectedFiles) => {
     if (rejectedFiles.length > 0) {
      handleSetValues('invalidFile');
     }

    if (values.activeStep === 2 && acceptedFiles.length > 1) { 
      setUploadedFiles(false);
      return;
    } else if (values.activeStep === 2 && acceptedFiles.length === 1) {
      setUploadedFiles(true);
    }


   
    acceptedFiles.map(async (file, index) => {
      const reader = new FileReader();
      const bytesToMegaBytes = file.size / (1024 * 1024);
      const fileSize = `${bytesToMegaBytes.toFixed(2)}MB`;

      const logDetails = { 
        supplementId: values.supplementId,
        claimNumber: values.details.claimNumber.value,
        file: {
          category,
          name: file.name,
          type: file.type, 
          size: file.size,
          sizeMB: bytesToMegaBytes,
          inputEventFileIndex: index,
          inputEventFileCount: acceptedFiles.length
        },
        uploadContext: {
          totalUploadSize: values.uploads.totalUploadSize,
          fileCount: values.uploads.files.length
        }
      };
     // log({ event: 'file_input', ...logDetails });

      if (bytesToMegaBytes < MIN_FILE_SIZE) {
        log({ event: 'file_input_min_size_error', ...logDetails }, 'warn');
        values.uploads.minFileSizeNames.add(file.name);
      } else if (bytesToMegaBytes > MAX_FILE_SIZE) {
        log({ event: 'file_input_max_size_error', ...logDetails }, 'warn');
        values.uploads.maxFileSizeNames.add(file.name);
      } else if (values.uploads.totalUploadSize + bytesToMegaBytes > MAX_TOTAL_FILE_SIZE) {
        log({ event: 'file_input_max_total_size_error', ...logDetails }, 'warn');
        values.uploads.maxTotalFileSizeNames.add(file.name);
      } else if (values.uploads.files.length + index >= MAX_FILE_COUNT) {
        log({ event: 'file_input_max_count_error',  ...logDetails }, 'warn');
        values.uploads.maxFileCountNames.add(file.name);
      } else {
        values.uploads.totalUploadSize += bytesToMegaBytes;
        reader.onload = function (e) {
          handleSetValues('filesAdded', [{
            id: cuid(),
            category,
            name: file.path,
            rawSize: bytesToMegaBytes,
            src: e.target.result,
            size: fileSize,
            type: file.type
          }]);
        };
        reader.readAsDataURL(file);
        setFinalFiles((prevFiles) => [...prevFiles, ...acceptedFiles]);
         if (values.uploads.minFileSizeError || values.uploads.maxFileSizeError || 
         values.uploads.maxTotalFileSizeError || values.uploads.maxFileCountError) {
          console.log('File upload errors detected');
        handleSetValues('clearMinFileSizeError');
        handleSetValues('clearMaxFileSizeError');
        handleSetValues('clearMaxTotalFileSizeError');
        handleSetValues('clearMaxFileCountError');
        handleSetValues('clearInvalidFile');
      }
        return file;
      }
    });
    if (values.uploads.minFileSizeNames.size > 0) {
      handleSetValues('setMinFileSizeError');
    } else if (values.uploads.maxFileSizeNames.size > 0) {
      handleSetValues('setMaxFileSizeError');
    } else if (values.uploads.maxTotalFileSizeNames.size > 0) {
      handleSetValues('setMaxTotalFileSizeError');
    } else if (values.uploads.maxFileCountNames.size > 0) {
      handleSetValues('setMaxFileCountError');
    }
}, [category, handleSetValues, values.uploads]);

  // Add this helper function above your return statement


  return (    
    <Box style={{ paddingBottom: '20px,', paddingTop: hasError ? '0px' : ERROR_HEIGHT }}>
      <Heading type='h3-light' >
        {heading}
      </Heading>
      <BodyText style={{ font: 'roboto regular 16', fontSize: '16px', lineHeight: '25.6px', maxWidth: '665px' }}>
        {subHeading}
        {setCategoryText(category, text)}

        {!uploadedFiles ?
        <FieldGroup
  id="fieldgroup--error"
 
  messages={[
    {
      text: 'Please upload only 1 file',
      type: 'error'
    }
  ]}
></FieldGroup>
        
         : null}
        <FileUpload
        style={{ marginBottom: '24px' }}
        onDrop={onDrop}
          accept={setAcceptedFiles(category)}
          disabled={values.activeStep === 2 && oneValidFile}
          required={true}
          highlightType={!uploadedFiles ? 'error' : undefined}
          requirementsText=""
          multiple={true}
        
        />
      </BodyText>

      {values.activeStep === 3 && filterFilesByCategory.length > 0 && setPhotoText(UPLOADS.OTHER.POPOVER)}
      {filterFilesByCategory.length > 0 && <div style={{ paddingTop: '16px' , paddingBottom:'12px' }}>
        <DataTable>
          <Heading style={{ 
fontWeight: 'bold',
fontSize: '18px',
leadingTrim: 'NONE',
lineHeight: '28.8px',
letterSpacing: '0%'

}}>

 
            Uploaded files
          </Heading>
          <StyledTableWrapper $isMobile={isMobile}>
          <Table spacing="compact">
            <TableHeader>
              <TableRow />
            </TableHeader>
            <TableBody>
              {finalFiles.length === 0 ? (
                <TableRow>
                  <TableCell style={{ textAlign: 'center' }}>
                    No files uploaded.
                  </TableCell>
                </TableRow>
              ) : (filterFilesByCategory.length > 0 && filterFilesByCategory.map((file,index) => (

                 
               <ResponsiveTableRow key={index} $isMobile={isMobile}>
                    
                       <ContentCell $isMobile={isMobile}>
                      <div style={{ wordWrap: 'break-word', lineHeight: '25.6px',marginBottom:'16px',marginTop:'32px' }}>
                        {file.name.slice(2).trim().replace(/&nbsp;/g, ' ').replace(/\s+/g, ' ')}</div> 
                      <ThumbnailsGrid file={file} />
                    </ContentCell>
                      <ControlsCell $isMobile={isMobile}>
                     { values.activeStep === 2 && 
                      
                       <AlphanumericInput
                         style={{ width: '200px',marginBottom: window.innerWidth < 660 ? '16px' : '0' }}
                         id="Alphanumeric--default"
                         labelVisual='This file is..'
                         value={ 'Estimate or Invoice'}
                         disabled
                       />
                   
                      }
                      {values.activeStep === 3 && 
                    
                    <>{!file.category && <FieldGroup style={{ marginTop:'0px', 
                      marginBottom: window.innerWidth < 660 ? '16px' : '0' }}
                        messages={[
                          {
                            text: 'Please select a file type',
                            type: 'error'
                          }
                        ]}></FieldGroup>}

                        <StyledSelect
                         
                          id="select--default"
                          isRequired
                          defaultValue={getSelectedOption(file.category)}
                         
                          labelVisual="This file is ..."
                          onChange={(selectedOption) => handleSelection(file, selectedOption)}
                          placeholderOption="Pick your Option"
                          highlightType={!file.category ? 'error' : undefined}
                        >

                          <SelectOption value="photos">
                            Photos
                          </SelectOption>
                          <SelectOption value="other">
                            Documents
                          </SelectOption>
                         </StyledSelect></>
  
 }
                   
                    <IconButton
                      background="transparent"
                      aria-label="Delete button"
                      onClick={() => handleDelete(file)}
                      style={{
                       marginLeft: window.innerWidth < 660 ? '0' : '16px',
                       top:'16px'
                     }}
                    >
                      <IconTrash size="16" color="teal" aria-hidden="false" />
                    </IconButton>
                  </ControlsCell>
                  </ResponsiveTableRow>

              ))
              )}
            </TableBody>
          </Table>
          </StyledTableWrapper>
        </DataTable>
      </div>}
    </Box>
  );
};

DocumentUpload.propTypes = {
  category: PropTypes.string,
  text: PropTypes.object,
   $isMobile: PropTypes.bool
};

export default DocumentUpload;
